'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsAgo;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearsAgo.js
// module id = 763
// module chunks = 0